/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Row, Col, Spin, message, Tooltip, notification, Modal } from "antd";
import { ToolOutlined, InfoCircleOutlined } from "@ant-design/icons";
import useCustomNavigate from "../../components/customNavigationHook";
import Smcs_New_Logo from "../../assests/images/Smcs_New_Logo.png";
import Smcs_Loader from "../../assests/images/loader-new.gif";
import { WarningTwoTone } from "@ant-design/icons";
import axios from "axios";
// import Cookies from "universal-cookie";
import { capitaliseWithHyphen } from "../../utils";
import API from "../../api";
import { APIs } from "../../utils/worker";
import {
  getAccountService,
  loginUser,
} from "../../actionsMethods/cashBookingMethods";
import { CloseCircleOutlined } from "@ant-design/icons";

import "antd/dist/antd.css";
import "./index.scss";
import constants from "../../constants/constants";
import CompanySelection from "./LoginComponents/CompanySelection";
import LoginForm from "./LoginComponents/LoginForm";
import urls from "../../api/urls";
import { maintenanceConfig } from "../../config/maintenance";
import MaintenancePage from "../../components/Maintenance";
import smartSensePoster from "../../assests/images/modal/iSmartSenseAI.png";
import OCRBooking from "../../assests/images/modal/OneBookingVideo1.mp4";
import { customerOnboardingAPI } from "../../api/LeadApi";

const {
  GET_SEVA_USER_EMAIL,
  VALIDATE_SEVA_USER,
  VALIDATE_SEVA_OTP,
  GET_COMPANY_LIST,
  GET_QA_COMPANY_LIST,
} = urls;

const NormalLoginForm = () => {
  const dispatch = useDispatch();
  const navigate = useCustomNavigate();
  const ADMIN_ROLES = [
    constants.ROLES.CP_ADMIN,
    constants.ROLES.CP_OPERATOR,
    constants.CLIENT_ADMIN,

    constants.ROLES.CP_BOOKINGONLY,
  ];

  const [errorMessage, setErrorMessage] = useState();
  const [loading, setLoading] = useState(false);
  const [listLoading, setListLoading] = useState(false);

  const [rememberMe, setRememberMe] = useState(false);
  const [spId, setSpId] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [isAdminOperator, setIsAdminOperator] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [showMaintenance, setShowMaintenance] = useState(false);
  const [isEnableCP, setIsEnableCP] = useState(true);
  const { baseURLInnofulfill } = APIs;

  const currentEnv = process.env.REACT_APP_ENV;

  ///---Maintenance Logic---///
  useEffect(() => {
    maintenanceConfig.isActive && showCenteredNotification();
  }, []);

  ///---Check if already authenticated and redirect---///
  useEffect(() => {
    const checkExistingAuth = () => {
      const userInfo = localStorage.getItem("loggedOutTime");
      const userRoles = localStorage.getItem("userinfo");
      const userName = localStorage.getItem("userName");
      const selectedCompany = localStorage.getItem("selectedCompany");

      // Check if we have basic authentication data
      if (userInfo && userRoles && userName) {
        const currentTime = new Date().getTime();
        const sessionExpiry = JSON.parse(userInfo);
        
        // Check if session is still valid
        if (currentTime < sessionExpiry) {
          const parsedUserRoles = JSON.parse(userRoles);
          const isAdmin = parsedUserRoles?.roles?.some((role) => 
            ADMIN_ROLES?.includes(role)
          );

          // For admin users, check if company is selected
          if (isAdmin && currentEnv !== "dev") {
            if (selectedCompany) {
              // Admin with company selected - redirect to dashboard
              window.location.href = "/dashboard";
            }
            // Admin without company - stay on login page to select company
          } else {
            // Non-admin user - redirect to dashboard
            window.location.href = "/dashboard";
          }
        }
      }
    };

    checkExistingAuth();
  }, []);

  const showCenteredNotification = () => {
    const key = "maintenance-notification";
    notification.open({
      message: null, // Exclude the default title
      description: (
        <div style={{ display: "flex", alignItems: "center" }}>
          <div>
            <h3 style={{ marginBottom: "8px", fontWeight: 600, color: "red" }}>
              <WarningTwoTone style={{ fontSize: "2rem" }} /> &nbsp;
              {maintenanceConfig?.title}
            </h3>
            <p style={{ margin: 0, fontSize: "14px" }}>
              {maintenanceConfig?.description}
            </p>
          </div>
        </div>
      ),
      duration: 0,
      style: {
        position: "fixed",
        top: "10px",
        left: "50%",
        transform: "translateX(-50%)",
        textAlign: "center",
        width: "100%",
        maxWidth: "650px",
        backgroundColor: "#fffbe6", // Soft yellow
        border: "1px solid #ffe58f",
        borderRadius: "10px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
        padding: "30px 90px",
      },
      closeIcon: <span style={{ display: "none" }} />,
      key,
    });
  };

  ///----///

  const showMessageError = () => {
    message.info({
      closable: true,
      className: "login-notice-message",
      content: (
        <>
          <span>
            <span style={{ fontSize: 18 }}>
              If you are unable to log in, please use the{" "}
              <strong
                className="pointer"
                style={{
                  textDecoration: "underline",
                  color: "rgb(60, 45, 176)",
                }}
                onClick={() => {
                  message.destroy();
                  setModalVisible(true);
                  localStorage.setItem("showNotice", false);
                }}
              >
                CREATE NEW USER{" "}
              </strong>{" "}
              option with your SevaSetu username
            </span>
          </span>
          <Tooltip title="Close" placement="bottom">
            <span className="pointer ml-1">
              <CloseCircleOutlined />
            </span>
          </Tooltip>
        </>
      ),
      onClick: (event) => {
        if (event.target.className.baseVal == "") {
          localStorage.setItem("showNotice", false);
          message.destroy();
        }
      },
      duration: 30, // in seconds
    });
  };

  const [showNotice, setShowNotice] = useState(
    localStorage.getItem("showNotice") || true
  );

  useEffect(() => {
    if (
      (JSON.parse(showNotice) == true || showNotice == "null") &&
      !maintenanceConfig.isActive
    ) {
      showMessageError();
    }
  }, []);

  const getLoginResponse = useSelector(
    (state) => state?.appReducer?.loginUser,
    shallowEqual
  );

  const getAccountServiceResponse = useSelector(
    (state) => state?.appReducer?.getAccountServiceReducer,
    shallowEqual
  );

  const { error, fetching, result } = getLoginResponse;

  const {
    fetching: accountFetching,
    result: accountResult,
    error: accountError,
  } = getAccountServiceResponse;

  function addHours(date, hours) {
    date.setTime(date.getTime() + hours * 60 * 60 * 1000);
    return date;
  }

  const rolePriority = {
    ROLE_CPADMIN: 1,
    ROLE_BOOKINGONLY: 2,
    ROLE_CPOPERATOR: 3,
  };

  function getHighestRole(roles) {
    return roles?.reduce((highest, role) => {
      return rolePriority[role] < rolePriority[highest] ? role : highest;
    }, roles[0]);
  }

  useEffect(() => {
    const setLocalStore = async () => {
      const selectedCompany = JSON.parse(
        localStorage.getItem("selectedCompany")
      );

      if (selectedCompany) {
        window.location.href = "/dashboard";
        return;
      }

      if (result !== null) {
        const isAdmin =
          (result?.roles?.some((role) => ADMIN_ROLES?.includes(role)) &&
            currentEnv !== "dev") ||
          false;

        const isEnable =
          result?.isEnable === null || result?.isEnable ? true : false;
        if (isAdmin && currentEnv === "qa") {
          setIsEnableCP(isEnable);
          localStorage.setItem("isEnableCP", JSON.stringify(isEnable));
        }
        if (!isEnable && currentEnv === "qa") {
          localStorage.setItem(
            "customerId",
            JSON.stringify(result?.customerId)
          );
        }

        if (
          maintenanceConfig.isActive &&
          !maintenanceConfig.testUsers.includes(result.spId)
        ) {
          setShowMaintenance(true);
        } else {
          if (
            result?.roles?.some((role) =>
              constants.ROLES.CP_ADMIN?.includes(role)
            )
          ) {
            localStorage.setItem(
              "kycCompleted",
              JSON.stringify(result?.kycCompleted)
            );
          }
          if (result?.roles?.length > 1) {
            result.roles = [getHighestRole(result?.roles)];
          }

          setIsAdminOperator(isAdmin);
          localStorage.setItem("userinfo", JSON.stringify(result));

          setSpId(result?.spId);
          const object = { name: result?.accessToken, email: result?.username };
          document.cookie = "userToken=" + JSON.stringify(object);
          let sec = result?.expiresIn;
          let hour = parseInt(sec / 3600);
          const result1 = addHours(new Date(), hour);
          localStorage.setItem(
            "loggedOutTime",
            JSON.stringify(result1?.getTime())
          );

          if (!result?.spId && isAdmin && currentEnv === "prod") {
            message.error("Signup process is not completed.");
            return;
          }

          if (isAdmin) {
            setListLoading(true);
            let response;
            if (currentEnv === "qa") {
              response = await API.Api(
                `${GET_QA_COMPANY_LIST}/on-boarding/company/v1?cpId=${
                  result?.premiseId
                }&isActive=${true}`
              ).getCustomToken(result?.accessToken);
            } else {
              response = await API.Api(
                `${GET_QA_COMPANY_LIST}/on-boarding/company/v1?cpId=${
                  result?.premiseId
                }&isActive=${true}`
              ).getCustomToken(result?.accessToken);
            }
            // SEVASETU_COMPANY_ID
            if (response?.status) {
              setListLoading(false);
              const comp = response?.response?.data?.data;

              if (currentEnv == "qa" || currentEnv == "prod") {
                const result = comp?.map((item) => {
                  const sevSetuCompanyId = item?.metadata?.find(
                    (meta) => meta?.key === "SEVASETU_COMPANY_ID"
                  )?.value;

                  const prospayCustomerId = item?.metadata?.find(
                    (meta) => meta?.key === "PROSPAY_CUSTOMER_ID"
                  )?.value;
                  const companyName = item?.metadata?.find(
                    (meta) => meta?.key === "ALIAS_COMPANY_NAME"
                  )?.value;

                  const isKycCompleted = item?.kycDocuments?.some(
                    (doc) => doc?.verified
                  );

                  const sharedKYCCompanyName = item?.kycDocuments?.find(
                    (meta) => meta?.isSharedKyc
                  )?.sharedKycCompanyName;

                  const companyId = item?.customerData?.companyId;

                  const checkRegularNGST = item?.metadata?.find(
                    (meta) => meta?.key === "IS_REGULAR"
                  )?.value;

                  const checkGSTExemption = item?.kycDocuments?.find(
                    (meta) => meta?.idType == "GST"
                  )?.idNumber;

                  return {
                    companyName: companyName || "N/A",
                    companyId: sevSetuCompanyId,
                    sharedKYCCompanyName: sharedKYCCompanyName,
                    prospayCustomerId: prospayCustomerId,
                    customerId: item.customerId,
                    newCompanyId: companyId,
                    isKycCompleted: isKycCompleted,
                    isRegularNGST:
                      checkRegularNGST && checkGSTExemption?.length > 0,
                  };
                });

                setSpId("1");

                setCompanies(
                  result?.map((item, id) => ({
                    key: item?.companyId,
                    sharedKYCCompanyName: item?.sharedKYCCompanyName,
                    value: item?.companyName + item?.companyId,
                    label: capitaliseWithHyphen(item?.companyName),
                    isRegularNGST: item?.isRegularNGST,

                    customerId: item?.customerId,
                    newCompanyId: item?.newCompanyId,
                    isKycCompleted: item?.isKycCompleted,
                    prospayCustomerId: item?.prospayCustomerId,
                    cashQuotationName:
                      item?.quotations?.find(
                        (rate) => rate?.rateCardType?.toUpperCase() === "CASH"
                      )?.rateCardName || null,
                  }))
                );
              } else {
                setCompanies(
                  comp.map((item, id) => ({
                    isKycCompleted: item?.kycDocuments?.some(
                      (doc) => doc?.verified
                    ),
                    key: item?.CompanyID,
                    value: item?.AliasCompanyName + item?.CompanyID,
                    label: capitaliseWithHyphen(item?.AliasCompanyName),
                    prospayCustomerId: item?.prospay_customer_id,
                    isRegularNGST: item?.isRegularNGST,

                    customerId: item?.customerId,
                    newCompanyId: item?.newCompanyId,
                  }))
                );
              }
            } else {
              setListLoading(false);
              setErrorMessage(error?.message);
            }
          }
        }
      } else {
        setErrorMessage(error?.message);
      }
    };
    setLocalStore();
  }, [result, error, fetching]);

  useEffect(() => {
    if (result) {
      dispatch(getAccountService(result?.username, result?.accessToken));
    }
  }, [result]);

  useEffect(() => {
    if (accountError) {
      setLoading(false);
      message.error(accountError?.message);
    }
  }, [accountError]);

  useEffect(() => {
    if (accountResult !== null) {
      localStorage.setItem("userId", JSON.stringify(accountResult));
      localStorage.setItem(
        "userName",
        JSON.stringify(accountResult?.userInfo?.firstName)
      );
      // console.log(
      //   isAdminOperator,
      //   isEnableCP,
      //   "isAdminOperator, isEnableCP",
      //   isAdminOperator && !isEnableCP
      // );

      if (isAdminOperator && isEnableCP === false && currentEnv === "qa") {
        handleRedirectDashboard();
      }
      if (!isAdminOperator && !showMaintenance) {
        handleRedirectDashboard();
      }
      // navigate("/dashboard");
    }
  }, [getAccountServiceResponse]);

  const onFinish = async (values) => {
    delete values.remember;
    // emailInput.value.trim()
    const payload = {
      ...values,
      username: values?.username?.trim()?.toLowerCase(),
    };
    dispatch(loginUser(payload));
  };

  const handleForgot = () => {
    navigate("/forgotPassword");
  };

  const clearCaches = async () => {
    if ("caches" in window) {
      const names = await caches.keys();

      await Promise.all(names.map((name) => caches.delete(name)));
    }
  };

  const unregisterServiceWorkers = async () => {
    if ("serviceWorker" in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((reg) => reg.unregister()));
    }
  };

  const handleRedirectDashboard = () => {
    setLoading(true);

    if (accountResult !== null) {
      localStorage.setItem(
        "selectedCompany",
        JSON.stringify(selectedCompany) || null
      );

      clearCaches();
      unregisterServiceWorkers();
      window.location.replace("/dashboard");
      setLoading(false);
    } else {
      setLoading(false);
      message.error("Failed to fetch User Id");
    }
  };

  const [userDetails, setUserDetails] = useState({
    data: "",
    validEmail: false,
  });

  const getUserEmail = async (param) => {
    if (!param) {
      message.error("Enter user name");
      return;
    }
    setLoading(true);
    let baseUrl;

    if (currentEnv == "qa") {
      baseUrl =
        "https://sandbox.bookingapis.innofulfill.com/pincode/sevasetu-user/" +
        encodeURIComponent(param?.trim());
    } else {
      baseUrl = GET_SEVA_USER_EMAIL + encodeURIComponent(param?.trim());
    }

    let res = await API.Api(baseUrl).getWithNoToken();

    setLoading(true);
    if (res?.status) {
      setLoading(false);
      const response = res?.response?.data;
      setUserDetails({
        data: { email_id: response?.data?.email },
        userEmail: response?.data?.email,
        updatedEmail: response?.data?.email,

        validEmail: false,
        userName: param,
        isRegistered: response?.data?.isRegistered,
        validEmailMessage: response?.data?.message,
      });
    } else {
      setUserDetails({
        InvalidEmailMessage:
          "You are not linked to any Channel Partner (CP). Please contact your CP Administrator for assistance.",
      });
      // message.error(
      //   " You are not linked to any Channel Partner (CP). Please contact your CP Administrator for assistance."
      // );
      setLoading(false);
    }
  };

  const validateEmail = async (data) => {
    let payload = {
      recipient: userDetails?.data?.email_id?.trim(),
      channel: "email",
      productName: "bookings",
    };

    try {
      let checkUpdateEmail =
        userDetails?.data?.email_id?.trim() == userDetails?.updatedEmail?.trim()
          ? false
          : true;

      if (checkUpdateEmail) {
        payload.updatedEmail = userDetails?.updatedEmail?.trim();
        payload.username = userDetails?.userName?.trim();
      }

      setLoading(true);
      let baseUrl;

      if (currentEnv == "qa") {
        baseUrl =
          "https://sandbox.bookingapis.innofulfill.com/otp-verification/generate";
      } else {
        baseUrl =
          "https://bookingapis.innofulfill.com/otp-verification/generate";
      }

      let response = await axios.post(baseUrl, payload);
      if (response?.status === 201) {
        setLoading(false);
        const res = response?.response?.data;
        message.success("OTP sent to E-mail");
        setUserDetails((prev) => ({
          ...prev,
          validEmail: true,
          userEmail: checkUpdateEmail
            ? userDetails?.updatedEmail?.trim()
            : data?.trim(),
          otpVerified: false,

          // validEmailMessage: "This is not your email contact admin",
        }));
      }
    } catch (error) {
      console.log(error, "error ");
      message.error(error?.response?.data?.message || "Network error catch");
      setLoading(false);
    }
  };

  const validateOTP = async (data, newEmail) => {
    if (!data) {
      message.error("Enter OTP");
      return;
    }
    try {
      setLoading(true);
      let baseUrl;
      if (currentEnv == "qa") {
        baseUrl =
          "https://sandbox.bookingapis.innofulfill.com/otp-verification/verify";
      } else {
        baseUrl = APIs.baseURLInnofulfill + "/otp-verification/verify";
      }

      let response = await axios.post(baseUrl, {
        otp_code: data?.trim(),
        recipient: userDetails?.updatedEmail?.trim(),
        // recipient: "amit12@mailinator.com" || userDetails?.userEmail,
        channel: "email",
        productName: "bookings",
        // username: "amit12@mailinator.com" || userDetails?.userName,
        username: userDetails?.userName?.trim(),
      });

      if (response?.status === 201) {
        setLoading(false);

        const isVerifiedRes = response?.data?.isVerified;

        if (isVerifiedRes) {
          message.success("OTP verified successfully");
          if (response?.data?.userExists) {
            setUserDetails((prev) => ({
              ...prev,
              validEmail: true,
              otpVerified: true,
              optSuccessMessage:
                "Your account already exists, You can use the same or reset it via",
            }));
            // window.location.replace(response?.data?.link);
          } else {
            if (!response?.data?.userExists) {
              // console.log("reidrect");
              window.location.replace(response?.data?.link);
            }
          }
        } else {
          setLoading(false);
          message.error("Wrong OTP");
        }
      }
    } catch (error) {
      message.error(error?.response?.data?.message || "Network error");
      setLoading(false);
    }
  };
  const { ISMART_SENSE_FORM_URL } = constants;
  const handleOk = () => {
    window.open(ISMART_SENSE_FORM_URL, "_blank");
  };

  return (
    <div>
      <div className="login-main-container">
        <Spin
          spinning={fetching || loading || accountFetching}
          size="large"
          indicator={
            <img
              src={Smcs_Loader}
              style={{ height: "100px", width: "100px" }}
            />
          }
        >
          <Row>
            <Col
              className="img-parent"
              xl={12}
              lg={12}
              md={12}
              sm={0}
              xs={24}
              // className={"logibg-container"}
            >
              <div className="img-div"></div>
            </Col>
            <Col
              xl={12}
              lg={12}
              md={12}
              sm={24}
              xs={24}
              // style={{
              //   margin: "0 auto",
              //   position: "relative",
              //   backgroundColor: " #ffffff",
              // }}
              className="login-parent"
            >
              <div className="login-container" style={{ height: "100vh" }}>
                <div className="small-screen-logo">
                  <img
                    src={Smcs_New_Logo}
                    alt="smcs-logo"
                    className="login-img"
                  />
                </div>
                {!showMaintenance ? (
                  spId === null ? (
                    <LoginForm
                      errorMessage={errorMessage}
                      loading={loading}
                      onFinish={onFinish}
                      handleForgot={handleForgot}
                      getUserEmail={getUserEmail}
                      validateEmail={validateEmail}
                      validateOTP={validateOTP}
                      userDetails={userDetails}
                      setUserDetails={setUserDetails}
                      modalVisible={modalVisible}
                      setModalVisible={setModalVisible}
                    />
                  ) : (
                    isAdminOperator &&
                    spId && (
                      <CompanySelection
                        companies={companies}
                        loading={listLoading}
                        handleRedirectDashboard={handleRedirectDashboard}
                        setSelectedCompany={setSelectedCompany}
                      />
                    )
                  )
                ) : (
                  <MaintenancePage
                    setMaintenance={(prev) => {
                      setShowMaintenance(prev);
                    }}
                  />
                )}

                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    cursor: "pointer",
                  }}
                >
                  {/* <img
                    src={smartSensePoster}
                    style={{ width: "100%" }}
                    onClick={handleOk}
                  /> */}
                  <a
                    href={
                      "https://play.google.com/store/apps/details?id=io.prayog.ismartsense.smile"
                    }
                    target="_blank"
                    rel="noreferrer"
                  >
                    <video
                      src={OCRBooking}
                      autoPlay
                      muted
                      loop
                      playsInline
                      style={{
                        width: "100%",
                        borderRadius: "12px",
                      }}
                    />
                  </a>
                </div>

                <div
                  className="footer"
                  style={{
                    position: "sticky",
                    bottom: 0,
                    display: "flex",
                    justifyContent: "center",
                    // border: "2px solid red",
                    // width: "70%",
                  }}
                >
                  <p>
                    Copyright © {new Date().getFullYear()} Shree Maruti
                    Integrated Logistics Limited
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Spin>
        {/* <Modal title="" open={true} footer={null}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <WarningTwoTone style={{ fontSize: "10rem" }} />
          <p style={{ color: "red", fontSize: "2rem" }}>Under Maintenance!</p>
        </div>
      </Modal> */}
      </div>
    </div>
  );
};

export default NormalLoginForm;
